import Papa from "papaparse";

export default {
    fieldDataTypes: [
        {
            type: "Number",
            patterns: [
                /^-?[0-9]+$/
            ]
        },
        {
            type: "Boolean",
            patterns: [
                /^(true|false|True|False|TRUE|FALSE)$/
            ]
        },
        {
            type: "EmailAddress",
            patterns: [
                /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
            ]
        },
        {
            type: "Decimal",
            patterns: [
                /^-?[0-9]+$/,
                /^-?\.[0-9]+$/,
                /^-?[0-9]+\.[0-9]+$/
            ]
        },
        {
            type: "Date",
            patterns: [
                /^[0-9]+\/[0-9]+\/[0-9]+$/,
                /^[0-9]+\/[0-9]+\/[0-9]+\s+[0-9]+:[0-9]+(:[0-9]+(\.[0-9]+)?([a-zA-Z0-9]+)?)?$/,
                /^[0-9]+-[0-9]+-[0-9]+$/,
                /^[0-9]+-[0-9]+-[0-9]+(\s+|T)[0-9]+:[0-9]+(:[0-9]+(\.[0-9]+)?([a-zA-Z0-9]+)?)?$/
            ]
        },
        {
            type: "Text",
            patterns: [
                /.*/
            ]
        }
    ],
    splitData: function(str) {
        var result = Papa.parse(str);
        return result.data;
    },
    getFieldDataTypes: function() {
        var fieldDataTypes = [];
        this.fieldDataTypes.forEach((fieldDataType) => {
            fieldDataTypes.push(fieldDataType.type);
        });
        return fieldDataTypes;
    },
    makeFromRows: function(rows) {
        var i, fields = [], header, m, fieldProperties, sendableField = null;
        var headers = rows.shift();
        for (i = 0; i < headers.length; i++) {
            header = headers[i].replace(/^\s+/, "").replace(/\s+$/, "");
            fieldProperties = {
                Ordinal: i + 1,
                Name: header,
                FieldType: this.getFieldDataType(rows, i)
            };
            m = header.match(/^([^(]+)\s*\((.+)\)$/);
            if (m) {
                fieldProperties.Name = m[1];
                header = m[1];
                m[2].split(/,/).forEach(option => {
                    option = option.replace(/^\s+/, "").replace(/\s+$/, "").toLowerCase();
                    if (
                        (option == "pkey") ||
                        (option == "primary key") ||
                        (option == "pk")
                    ) {
                        fieldProperties.IsPrimaryKey = "true";
                    } else if (
                        (option == "required") ||
                        (option == "reqd")
                    ) {
                        fieldProperties.IsRequired = "true";
                    } else if (
                        (option == "sendable")
                    ) {
                        sendableField = fieldProperties.Name;
                    }
                });
            }
            fields.push(fieldProperties);
        }

        for (i = 0; i < fields.length; i++) {
            this.getFieldProperties(rows, fields[i], i);
        }

        return {
            fields: fields,
            rows: rows,
            sendableField: sendableField
        };
    },
    getFieldDataType: function(rows, colIdx) {
        var i, j, k;
        var fieldDataType, haveDataTypeMatch, haveAPatternMatch;
        for (i = 0; i < this.fieldDataTypes.length; i++) {
            fieldDataType = this.fieldDataTypes[i];
            haveDataTypeMatch = true;
            for (k = 0; k < rows.length; k++) {
                if (
                    (typeof rows[k][colIdx] != "undefined") &&
                    (rows[k][colIdx] !== null) &&
                    (rows[k][colIdx].toString().length)
                 ) {
                    haveAPatternMatch = false
                    for (j = 0; j < fieldDataType.patterns.length; j++) {
                        if (rows[k][colIdx].toString().match(fieldDataType.patterns[j])) {
                            haveAPatternMatch = true;
                            break;
                        }
                    }
                    if (!haveAPatternMatch) {
                        haveDataTypeMatch = false;
                    }
                }
            }
            if (haveDataTypeMatch) {
                return fieldDataType.type;
            }
        }
        return "string";
    },
    getFieldProperties: function(rows, field, colIdx) {
        var i, m, val;
        if (field.FieldType.match(/^(Number|Date|Boolean)/)) {
            return;
        } else if (field.FieldType == "EmailAddress") {
            field.MaxLength = 254;
            return;
        }
        
        field.MaxLength = 16;

        for (i = 0; i < rows.length; i++) {
            if (
                (typeof rows[i][colIdx] != "undefined") &&
                (rows[i][colIdx] !== null) &&
                (rows[i][colIdx].toString().length)
             ) {
                val = rows[i][colIdx].toString();
                if (field.MaxLength < val.length) {
                    field.MaxLength = val.length;
                }
                if (field.FieldType == "Decimal") {
                    // eslint-disable-next-line
                    if (m = val.match(/^(-?)(\..+)$/)) {
                        rows[i][colIdx] = m[1]+"0"+m[2];
                    }
                    if (!val.match(/\./)) {
                        val += ".00";
                    }
                    m = val.split(/\./);
                    if (
                        (!field.Scale) ||
                        (field.Scale < m[1].length)
                    ) {
                       field.Scale = m[1].length;
                    }
                 }
             }
        }

        if ((field.FieldType == "Decimal") && !field.Scale) {
            field.MaxLength += 3;
            field.Scale = 2;
        }
    }
};
